module.exports = __webpack_public_path__ + "static/img/no-data.bba4e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-data.png
// module id = qLeS
// module chunks = 2